var CONTENT_CARD_ERROR_MESSAGES = {
  SRC_OR_EXHIBIT_MUST_BE_PROVIDED: 'Please provide either the "src" or "exhibit" prop to "ContentCard"'
};

export { CONTENT_CARD_ERROR_MESSAGES };
